import Component from '@glimmer/component';

export default class DateRangeWarningComponent extends Component {
  <template>
    <div
      class="c-warning qa-warn-dates"
      title="Dates outside the available date range will not be included in the output."
      ...attributes
    >
      {{~yield~}}
    </div>
  </template>
}
